<mat-card>
  <mat-card-header>
    <mat-card-title>
      Bookmarked Applications
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>

    <mat-table [dataSource]="dataSource" matSort>
      <!-- Application Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Application Name </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Application Name:</span>
          <div class="name-container">
            <div class="app-name">{{element.name}}</div><br>
            <div class="app-creationdate">Created: {{ element.creationdate|date:'mediumDate' }}</div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Description </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">Description:</span>
          {{element.description}}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row)"></mat-row>

    </mat-table>

  </mat-card-content>
  
  <mat-card-actions align="end">
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </mat-card-actions>
</mat-card>